export const ajaxResponseVm = {
	isError: false,
	errorMessage: null,
	data: null,
};

export const ajaxVm = {
	ajaxUrl: '',
	ajaxType: 'GET',
	ajaxData: null,
};

function post(url, data, dataType) {
	return ajaxCall({
		...ajaxVm,
		ajaxUrl: url,
		ajaxType: 'POST',
		ajaxData: data,
		ajaxdataType: dataType,
	});
}

export default {
	post,
};

export function ajaxCall(vm) {
	return new Promise(function (resolve, reject) {
		$.ajax({
			url: vm.ajaxUrl,
			data: vm.ajaxData,
			type: vm.ajaxType,
			dataType: vm.ajaxdataType,
			timeout: 180000, // 3 minutes
			contentType: vm.contentType,
			processData: vm.processData,
			beforeSend: function (xhr) {
				if (vm.requiresAuthentication) setAuthorizationHeader(xhr);
			},
			success: function (data) {
				if (vm.excludeFromActionTaken === undefined || vm.excludeFromActionTaken === false) {
					//app.timeout.stayLoggedInAction();
				}

				if (data.responseType) {
					// ToDo: Add an undefined property in the view and see how this is handled. DW.
					if (data.responseType && data.responseType === 'FORCELOGOUT') {
						//app.timeout.logoutUser(appSettings.LogoutReason_Forced);
					} else if (data.responseType && data.responseType === 'PERMISSIONDENIED') {
						//display popup or redirect to access denied page?
						//app.timeout.logoutUser(appSettings.LogoutReason_Forced);
					} else if (data.responseType && data.responseType === 'TIMEOUT') {
						//app.timeout.logoutUser(appSettings.LogoutReason_Timeout);
					} else if (data.responseType && data.responseType !== 'SUCCESS') {
						if (data.responseType === 'undefined') reject(Error('Unknown error.'));
						else if (data.responseMessage === 'Access denied') reject(Error('Sorry but you do not have access to this area.'));
						else reject(Error('The following error has occured: ' + data.responseMessage));
					}

					//Return result of webservice call (returning a VM not HTML)
					ajaxResponseVm.data = data;

					resolve(ajaxResponseVm);
				} else {
					//Falls in here if data is HTML

					//The attempt to make a local ajax call redirected to the IS login page
					//Should only occur if the timeout warning message fails to appear
					//This should attempt to reload the page (like pressing F5) and redirect to IS to re-authenticate
					if (data.hasOwnProperty('indexOf') && data.indexOf('login-background') > -1) {
						window.location.reload(true);
						reject(Error('Connection failure - please wait while this page reloads'));
					} else {
						// ToDo: This doesn't work if an error returned from a local service call

						// Update all controller actions which return html in applications.EDM to return the ajax response vm
						// once this is done we can just return 'data' into the resolve function.
						ajaxResponseVm.data = data;

						resolve(ajaxResponseVm);
					}
				}
			},
			error: function (jqXHR, exception) {
				var msg = '';
				if (jqXHR.status === 0) {
					msg = 'Not connected. Verify Network.';
				} else if (jqXHR.status === 404) {
					msg = 'Requested page not found [404].';
				} else if (jqXHR.status === 500) {
					msg = 'Something has gone wrong displaying this page.';
				} else if (exception === 'parsererror') {
					msg = 'Requested JSON parse failed.';
				} else if (exception === 'timeout') {
					msg = 'Timeout error [408].';
				} else if (exception === 'abort') {
					msg = 'Ajax request aborted.';
				} else {
					msg = 'Something has gone wrong. ' + jqXHR.responseText + ' ' + exception;
				}

				reject(Error(msg));
			},
		});
	});
}
